import { useLocation, useNavigate, useParams } from "react-router-dom";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { useEffect, useState } from "react";
import moment from "moment";
import {
  formatAmount,
  getTotalAmount,
  HandlePurchaseRequestStatus,
  handleUnderInBudget,
} from "../../../utility/CommonFunctions";
import { toast } from "react-toastify";
import { Spinner, Modal, ModalBody } from "reactstrap";
import { useSelector } from "react-redux";
import ApproveRejectModal from "../../../components/comman/ApproveRejectModal";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import CommonTable from "../../../components/comman/CommonTable";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import ViewIcon from "../../../components/Icons/ViewIcon";
import DocumentIcon from "../../../components/Icons/DocumentIcon";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import Logs from "../../Logs/Logs";
import MainHeading from "../../../components/comman/MainHeading";

export default function PurchaseOrderDetail() {
  let { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.root.userDetails);
  const [dataLoading, setDataLoading] = useState(false);
  const [refreshLogs, setRefreshLogs] = useState(false);
  const [pageStates, setPageStates] = useState({
    purchaseData: {},
    siteBudget: [],
    loading: false,
    IncreaseLoading: false,
    downloadLoading: false,
  });
  const [pageStatesPT, setPageStatesPT] = useState({
    tableLoader: false,
    PaymentTicketList: [],
    type: "AgainstPO",
  });
  const [pageStatesGRN, setPageStatesGRN] = useState({
    tableLoader: false,
    GRN_List: [],
    type: "AgainstPO",
  });
  const [modalType, setModalType] = useState("");
  const [modal, setModal] = useState(false);
  const toggle = () => {
    setModal(!modal);
  };

  const [selectedDocument, setSelectedDocument] = useState();
  const [documentModal, setDocumentModal] = useState(false);
  const toggleDocumentModal = () => {
    setDocumentModal(!documentModal);
  };

  const [increaseBudgetModal, setIncreaseBudgetModal] = useState(false);
  const toggleIncreaseBudgetModal = () => {
    setIncreaseBudgetModal(!increaseBudgetModal);
  };

  const handleDocumentClick = (doc) => {
    setSelectedDocument({ url: doc?.url });
    toggleDocumentModal();
  };

  useEffect(() => {
    GetPurchaseDetail();
  }, []);

  useEffect(() => {
    if (
      pageStates?.purchaseData?.status?.includes("Approved") ||
      pageStates?.purchaseData?.status?.includes("Director Created") ||
      pageStates?.purchaseData?.status?.includes("Short Closed")
    ) {
      GetPaymentTicket();
    }
  }, [pageStates?.purchaseData?.status]);

  useEffect(() => {
    if (
      pageStates?.purchaseData?.canViewGRN &&
      userDetails?.designation?.canCreate?.includes("grn")
    ) {
      GetGRN_List();
    }
  }, [pageStates?.purchaseData?.canViewGRN, userDetails]);

  const GetPurchaseDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_purchase_detail + `purchaseId=${id}`;
    setDataLoading(true);
    callApi(API, options).then((response) => {
      setDataLoading(false);
      if (response?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          purchaseData: response?.data,
        }));
        // console.log(response?.data?.purchaserequest);

        if (response?.data?.canChangeStatus) {
          let API2 =
            apiUrl?.get_site_budget +
            `siteId=${response?.data?.purchaserequest?.siteId}&type=${response?.data?.purchaserequest?.type === "supplyRequest"
              ? "supplyBudget"
              : "serviceBudget"
            }&financialYear=${response?.data?.financialYear}`;
          callApi(API2, options).then((res) => {
            if (res?.status === true) {
              setPageStates((prev) => ({
                ...prev,
                siteBudget:
                  response?.data?.purchaserequest?.purchaserequestexpenseheads
                    ?.map((budget) => {
                      const matchingExpense = res?.data?.find(
                        (item) =>
                          item?.expensehead?.id === budget?.expensehead?.id,
                      );

                      if (!matchingExpense) return null;

                      const expenseHead =
                        response?.data?.purchaserequest?.purchaserequestexpenseheads?.find(
                          (exp) =>
                            exp?.expensehead?.id ===
                            matchingExpense?.expensehead?.id,
                        );

                      if (!expenseHead) return null;

                      const amount =
                        expenseHead?.supplyrequestitems?.reduce((sum, item) => {
                          return (
                            sum +
                            getTotalAmount(
                              item,
                              response?.data?.purchaserequest?.type,
                            )
                          );
                        }, 0) || 0;

                      const differenceAmount =
                        +matchingExpense?.expectedAmount -
                        +matchingExpense?.freezedAmount;
                      const { underBudget, difference } = handleUnderInBudget(
                        amount,
                        differenceAmount,
                      );

                      return {
                        ...matchingExpense,
                        underBudget,
                        difference: differenceAmount,
                        isLoading: false,
                        differenceAmount: difference,
                      };
                    })
                    .filter(Boolean) || [],
              }));
            } else {
              toast.error(res?.message);
            }
          });
        }
      } else {
        toast.error(response?.message);
      }
    });
  };

  const GetPaymentTicket = (pageNo) => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_payment_ticket +
      MainFilterHandler(pageStatesPT) +
      `&purchaseId=${id}`;
    setPageStatesPT((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStatesPT((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.paymentTicket?.map((item) => ({
          ...item,
          siteName: item?.site?.name,
          paymentDate: moment(item?.date).format("DD-MM-YYYY"),
          createdBy: item?.user?.name,
          paymentTicketStatus: item?.status,
          paymentStatus:
            item?.remainingAmount === item?.totalAmount
              ? 0
              : item?.remainingAmount === 0
                ? 1
                : 2,
          grandTotal: formatAmount(item?.totalAmount),
          vendorName: item?.purchase?.vendor?.name,
          expenseName:
            item?.paymentticketexpenseheads[0]?.expensehead?.name +
            `${item?.paymentticketexpenseheads?.length > 1
              ? ` + ${item?.paymentticketexpenseheads?.length - 1}`
              : ""
            }`,
          remaining: formatAmount(item?.remainingAmount),
          paidAmount: formatAmount(item?.totalAmount - item?.remainingAmount),
        }));
        setPageStatesPT((pre) => ({
          ...pre,
          PaymentTicketList: newData,
        }));
      }
    });
  };

  const GetGRN_List = (pageNo) => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_GRN + MainFilterHandler(pageStatesGRN) + `&purchaseId=${id}`;
    setPageStatesGRN((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStatesGRN((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.grn?.map((item) => ({
          ...item,
          siteName: item?.site?.name,
          createdON: moment(item?.date).format("DD-MM-YYYY"),
          createdBy: item?.user?.name,
          paymentTicketStatus: item?.status,
        }));
        setPageStatesGRN((pre) => ({
          ...pre,
          GRN_List: newData,
        }));
      }
    });
  };

  const getAmountWithGst = (gst, total) => {
    return formatAmount((Number(gst) * total) / 100 + total);
  };

  const handleReqStatus = (status, reason = "") => {
    let postData = {
      status: status === "Short Closed" ? "Closed" : status,
      ...((status === "Rejected" || status === "Short Closed") && {
        rejectReason: reason,
      }),
    };
    const option = {
      method: "POST",
      data: postData,
    };
    setPageStates((pre) => ({
      ...pre,
      loading: true,
    }));
    callApi(apiUrl.update_purchase + `?purchaseId=${id}`, option).then(
      (res) => {
        setPageStates((pre) => ({
          ...pre,
          loading: false,
        }));
        toggle();
        if (res?.status) {
          toast.success(
            res?.message ||
            (status === "Short Closed"
              ? "PO Short Closed"
              : "Request Updated"),
          );
          if (status !== "Short Closed") {
            navigate(-1);
          }
          GetPurchaseDetail();
          setRefreshLogs(true);
        } else {
          toast.error(res?.message);
        }
      },
    );
  };

  const handleIncreaseSiteBudget = () => {
    if (pageStates?.purchaseData?.isInBudgetRequest) {
      toast.info("Request already sent!");
      return;
    }
    const postData = {
      purchaseId: id,
      budgetRequest: pageStates?.siteBudget
        ?.filter((budget) => !budget?.underBudget)
        ?.map((budget) => ({
          amount: Math.abs(budget?.differenceAmount),
          expenseHeadId: budget?.expenseheadId,
        })),
      siteId: pageStates.purchaseData?.purchaserequest?.site?.id,
    };
    // console.log("data>>>>", postData)
    const option = {
      method: "POST",
      data: postData,
    };
    setPageStates((pre) => ({
      ...pre,
      IncreaseLoading: true,
    }));

    callApi(apiUrl.increase_site_budget, option).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        IncreaseLoading: false,
      }));
      if (res?.status) {
        toast.success("Request Sent");
        toggleIncreaseBudgetModal();
        GetPurchaseDetail();
      } else {
        toast.error(res?.message);
      }
    });
  };

  const HandleView = (data) => {
    navigate(RoutesLink.payment_tickets_details + `/againstPo/${data?.id}`);
  };

  const HandleViewGRN = (data) => {
    navigate(RoutesLink.grn_detail + `/${data?.id}`);
  };

  const TableHeadingAgainstPo = [
    { value: "ticketNumber", label: "Ticket Number" },
    { value: "siteName", label: "Site Name" },
    { value: "paymentDate", label: "Date" },
    { value: "expenseName", label: "Expense Name" },
    { value: "createdBy", label: "Created By" },
    { value: "vendorName", label: "vendor name" },
    { value: "grandTotal", label: "Total Amount" },
    { value: "remaining", label: "Payable  Amount" },
    { value: "paidAmount", label: "Paid  Amount" },
    { value: "paymentStatus", label: "Payment Status" },
    { value: "paymentTicketStatus", label: "Status" },
  ];

  const TableHeadingForGRN = [
    { value: "grnNumber", label: "GRN Number" },
    { value: "siteName", label: "Site Name" },
    { value: "createdON", label: "Date" },
    { value: "createdBy", label: "Created By" },
    { value: "paymentTicketStatus", label: "Status" },
  ];

  const ActionData = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];

  const ActionDataForGRN = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleViewGRN,
    },
  ];

  const HandleDownloadPO = async () => {
    const API = `${apiUrl?.generate_purchase_order}purchaseId=${id}`;

    try {
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: true,
      }));
      const response = await callApi(API, { method: "GET" });
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: false,
      }));
      if (response?.status === true && response?.data) {
        const fileUrl = response?.data;
        const fileName = `Purchase Order_${pageStates?.purchaseData?.purchaseNumber || "Purchase Order"
          }.pdf`;

        const fileResponse = await fetch(fileUrl);

        if (!fileResponse.ok) {
          throw new Error("Failed to fetch the file for download");
        }

        const blob = await fileResponse.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // clean up
      } else {
        toast.error(response?.message || "Failed to fetch file URL");
      }
    } catch (err) {
      console.error(err);
      toast.error("Download failed. Please try again.");
    }
  };

  const calculateGrandTotal = () => {
    let grandTotal = 0;
    pageStates?.purchaseData?.purchaserequest?.purchaserequestexpenseheads?.forEach((exHead) => {
      exHead?.supplyrequestitems?.forEach((item) => {
        const amount = getTotalAmount(
          item,
          pageStates?.purchaseData?.purchaserequest?.type,
        );
        const gstVal = parseFloat(item?.gst) || 0;
        const gstAmount = (amount * gstVal) / 100;
        grandTotal += amount + gstAmount;
      });
    });
    return grandTotal;
  };

  return (
    <>
      {dataLoading && <BgBlurLoader />}
      <div className="content container-fluid ">
        <div className="d-flex justify-content-between">

          <MainHeading title="Purchase Order Detail" showBackButton={true} />

          <div className="content-head mb-5 d-flex align-items-center justify-content-between">
            <div className="d-flex gap-2">
              {pageStates?.purchaseData?.canCreateGRN &&
                userDetails?.designation?.canCreate?.includes("grn") && (
                  <button
                    type="button"
                    className="btn btn-outline-primary"
                    style={{ width: "14rem" }}
                    onClick={() =>
                      navigate(RoutesLink?.createGrn, {
                        state: {
                          data: pageStates?.purchaseData,
                          type: "Create",
                        },
                      })
                    }
                  >
                    Create GRN
                  </button>
                )}

              {pageStates?.purchaseData?.canDownloadPO && (
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  style={{ width: "14rem" }}
                  onClick={() => HandleDownloadPO()}
                  disabled={pageStates?.downloadLoading}
                >
                  {pageStates?.downloadLoading ? <Spinner /> : "Download PO"}
                </button>
              )}
            </div>
          </div>
        </div>

        <form action="">
          <div className="row">
            <div
              className={
                pageStates?.purchaseData?.canChangeStatus ? "col-9" : "col-12"
              }
            >
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <ul
                        className={
                          dataLoading
                            ? "row list-unstyled mt-4 loading-skeleton"
                            : "row list-unstyled mt-4"
                        }
                      >
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              PO NO. :-
                            </span>
                            {pageStates.purchaseData?.purchaseNumber
                              ? pageStates.purchaseData?.purchaseNumber
                              : "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              PR Number :-
                            </span>
                            {pageStates?.purchaseData?.purchaserequest
                              ?.requestNumber || "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Date :-
                            </span>
                            {pageStates.purchaseData?.purchaseDate
                              ? moment(
                                pageStates.purchaseData?.purchaseDate,
                              ).format("DD-MM-YYYY")
                              : "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Created By :-
                            </span>
                            {pageStates?.purchaseData?.user?.name || "--"}{" "}
                            {pageStates?.purchaseData?.user?.designation
                              ?.name && (
                                <span className="text-muted fs-5">
                                  (
                                  {
                                    pageStates?.purchaseData?.user?.designation
                                      ?.name
                                  }
                                  )
                                </span>
                              )}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Type :-
                            </span>
                            <span
                              className={`${pageStates?.purchaseData?.purchaserequest
                                ?.type === "supplyRequest"
                                ? "badge bg-blue-25 fw-normal rounded-pill"
                                : "badge bg-grey-25 fw-normal rounded-pill"
                                }`}
                            >
                              {pageStates?.purchaseData?.purchaserequest
                                ?.type === "supplyRequest"
                                ? "Supply"
                                : "Service" || "--"}
                            </span>
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Status :-
                            </span>
                            {HandlePurchaseRequestStatus(
                              pageStates.purchaseData?.status,
                            )}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Site :-
                            </span>
                            {
                              pageStates.purchaseData?.purchaserequest?.site
                                ?.name
                            }
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Vendor Name :-
                            </span>
                            {pageStates.purchaseData?.vendor?.name || "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Vendor Firm :-
                            </span>
                            {pageStates.purchaseData?.vendor?.firmName || "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Payment Term :-
                            </span>
                            {pageStates?.purchaseData?.paymentTerms || "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              GST Type :-
                            </span>
                            {pageStates?.purchaseData?.gstType || "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Remaining Amount :-
                            </span>
                            {formatAmount(
                              pageStates?.purchaseData?.remainingAmount || 0,
                            )}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Financial Year :-
                            </span>
                            {pageStates?.purchaseData?.financialYear || "--"}
                          </p>
                        </li>

                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Documents Checklist for Billing :-
                            </span>
                            {pageStates?.purchaseData?.gtc
                              ? JSON.parse(pageStates?.purchaseData?.gtc)
                                ?.length > 0
                                ? JSON.parse(
                                  pageStates?.purchaseData?.gtc,
                                )?.map((item, i) => (
                                  <span key={i}>
                                    {item}
                                    {i < JSON.parse(pageStates?.purchaseData?.gtc).length - 1 ? ", " : ""}
                                  </span>
                                ))
                                : "--"
                              : "--"}
                          </p>
                        </li>
                        {pageStates?.purchaseData?.rejectReason && (
                          <li className="col-12 col-md-6 col-lg-4">
                            <p>
                              <span className="text-muted fs-5 d-block">
                                Reject Reason :-
                              </span>
                              {pageStates?.purchaseData?.rejectReason || "--"}
                            </p>
                          </li>
                        )}
                      </ul>
                      {pageStates?.purchaseData?.canShortClose && (
                        <div className="d-flex justify-content-end mx-5">
                          <button
                            className="btn btn-danger px-5"
                            type="button"
                            onClick={() => {
                              setModalType("shortClose");
                              toggle();
                            }}
                          >
                            Short Close
                          </button>
                        </div>
                      )}
                    </div>

                    <div className="col-12 ">
                      <div className="d-flex align-items-center justify-content-between border-bottom mb-4">
                        <h4 className="fs-3 rajdhani-semibold my-4 ">
                          Item Details
                        </h4>
                      </div>
                      {pageStates?.purchaseData?.purchaserequest?.purchaserequestexpenseheads?.map(
                        (exHead, index) => {
                          let totalAmount = 0;
                          let totalAmountWithGST = 0;
                          return (
                            <div key={exHead.id} className="table-responsive">
                              <div className="d-flex align-items-center justify-content-between border-bottom mb-4">
                                <h4 className="fs-3 rajdhani-semibold my-4 ">
                                  {exHead?.expensehead?.name}
                                </h4>
                              </div>
                              <div className="table-responsive">
                                <table className="table table-hover align-middle nowrap w-100 mt-3">
                                  <thead>
                                    <tr>
                                      <th className="text-start">Item</th>
                                      <th className="text-start">HSN Code</th>
                                      <th className="text-start">Quantity</th>
                                      {pageStates?.purchaseData?.purchaserequest
                                        ?.type === "serviceRequest" && (
                                          <th className="text-start">Month</th>
                                        )}
                                      <th className="text-start">Rate</th>
                                      <th className="text-start">Amount</th>
                                      {pageStates?.purchaseData?.gstType ===
                                        "IGST" && (
                                          <th className="text-start">IGST</th>
                                        )}
                                      {pageStates?.purchaseData?.gstType ===
                                        "CGST + SGST" && (
                                          <>
                                            <th className="text-start">CGST</th>
                                            <th className="text-start">SGST</th>
                                          </>
                                        )}
                                      <th className="text-end">
                                        Amount With GST
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {exHead?.supplyrequestitems?.map(
                                      (item, i) => {
                                        const amount = getTotalAmount(
                                          item,
                                          pageStates?.purchaseData
                                            ?.purchaserequest?.type,
                                        );

                                        const gstVal = parseFloat(item?.gst) || 0;
                                        const gstAmount = (amount * gstVal) / 100;

                                        totalAmount += amount;
                                        totalAmountWithGST += gstAmount;
                                        return (
                                          <tr key={i}>
                                            <td className="desc-wrapper text-start">
                                              {item?.item?.name}
                                            </td>
                                            <td className="desc-wrapper text-start">
                                              {item?.item?.hsnCode || "--"}
                                            </td>
                                            <td className="desc-wrapper text-start">
                                              {item?.updatedQuantity}{" "}
                                              {item?.item?.unit}
                                            </td>
                                            {pageStates?.purchaseData
                                              ?.purchaserequest?.type ===
                                              "serviceRequest" && (
                                                <td className="desc-wrapper text-start">
                                                  {item?.month}
                                                </td>
                                              )}
                                            <td className="desc-wrapper text-start">
                                              {formatAmount(item?.rate)}
                                            </td>
                                            <td className="desc-wrapper text-start">
                                              {formatAmount(amount)}
                                            </td>
                                            {pageStates?.purchaseData
                                              ?.gstType === "IGST" && (
                                                <td className="desc-wrapper text-start">
                                                  {formatAmount(
                                                    (amount * gstVal) / 100,
                                                  )}{" "}
                                                  ({gstVal}%)
                                                </td>
                                              )}
                                            {pageStates?.purchaseData
                                              ?.gstType === "CGST + SGST" && (
                                                <>
                                                  <td className="desc-wrapper text-start">
                                                    {formatAmount(
                                                      (amount * gstVal) /
                                                      2 /
                                                      100,
                                                    )}{" "}
                                                    ({gstVal / 2}%)
                                                  </td>
                                                  <td className="desc-wrapper text-start">
                                                    {formatAmount(
                                                      (amount * gstVal) /
                                                      2 /
                                                      100,
                                                    )}{" "}
                                                    ({gstVal / 2}%)
                                                  </td>
                                                </>
                                              )}
                                            <td className="desc-wrapper text-end">
                                              {getAmountWithGst(
                                                gstVal,
                                                amount,
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      },
                                    )}
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td className="fw-bold text-start">
                                        Total
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      {pageStates?.purchaseData?.purchaserequest
                                        ?.type === "serviceRequest" && (
                                           <td></td>
                                         )}
                                      <td className="fw-bold text-start">
                                        {formatAmount(totalAmount)}
                                      </td>

                                      {pageStates?.purchaseData?.gstType ===
                                        "IGST" && (
                                          <td className="fw-bold text-start">
                                            {formatAmount(totalAmountWithGST)}{" "}
                                            (IGST)
                                          </td>
                                        )}

                                      {pageStates?.purchaseData?.gstType ===
                                        "CGST + SGST" && (
                                          <>
                                            <td className="fw-bold text-start">
                                              {formatAmount(
                                                totalAmountWithGST / 2,
                                              )}{" "}
                                              (CGST)
                                            </td>
                                            <td className="fw-bold text-start">
                                              {formatAmount(
                                                totalAmountWithGST / 2,
                                              )}{" "}
                                              (SGST)
                                            </td>
                                          </>
                                        )}

                                      <td className="fw-bold text-end">
                                        {formatAmount(totalAmount + totalAmountWithGST)}
                                      </td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            </div>
                          );
                        },
                      )}

                      <div className="d-flex justify-content-end mt-5 mb-3">
                        <div className="px-5 py-3 rounded text-end">
                          <h4 className="fs-3 fw-bold rajdhani-semibold mb-0">
                            Grand Total:&nbsp; {""}
                            <span className="text-primary fw-bold">
                              {formatAmount(
                                calculateGrandTotal(),
                              )}
                            </span>
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>

                  {pageStates?.purchaseData?.isInBudgetRequest && (
                    <div className="d-flex justify-content-center">
                      <span className="badge bg-yellow-25 text-dark fw-normal rounded-pill px-3 py-2">
                        There is a pending budget request of this PO first
                        approve or reject that then you can approve or reject
                        this PO
                      </span>
                    </div>
                  )}

                  {pageStates?.purchaseData?.canChangeStatus &&
                    pageStates?.siteBudget?.length > 0 && (
                      <div className="d-flex align-items-center justify-content-end gap-3">
                        <button
                          className="btn btn-danger px-5"
                          type="button"
                          onClick={() => {
                            setModalType("reject");
                            toggle();
                          }}
                        >
                          Reject
                        </button>
                        {pageStates?.siteBudget?.every(
                          (item) => item?.underBudget === true,
                        ) && (
                            <button
                              className="btn btn-success px-5"
                              type="button"
                              onClick={() => {
                                setModalType("approve");
                                toggle();
                              }}
                            >
                              Approve
                            </button>
                          )}
                      </div>
                    )}
                </div>
              </div>
            </div>
            {/* budget increase sidebar */}
            {pageStates?.purchaseData?.canChangeStatus && (
              <div className="col-3">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center border-bottom border-2 pb-2">
                          <h3 className="">Budgets</h3>
                          {location?.state?.isShow === false
                            ? ""
                            : pageStates?.siteBudget?.some(
                              (item) => item?.underBudget === false,
                            ) &&
                            !pageStates?.purchaseData?.isInBudgetRequest &&
                            userDetails?.type !== 2 && (
                              <button
                                className="btn btn-warning fs-5 p-2"
                                type="button"
                                disabled={pageStates.IncreaseLoading}
                                onClick={() => toggleIncreaseBudgetModal()}
                              >
                                {pageStates?.IncreaseLoading ? (
                                  <Spinner />
                                ) : (
                                  "Increase Budget"
                                )}
                              </button>
                            )}
                        </div>
                        {pageStates?.siteBudget &&
                          pageStates?.siteBudget?.length > 0 &&
                          pageStates?.siteBudget?.map((item, i) => {
                            return (
                              <ul key={i} className="row list-unstyled m-0 rounded p-2 px-3 mb-2 mt-3 border">
                                <li className="col-12 d-flex align-items-center justify-content-between px-0 mb-4">
                                  <h4 className="fs-4 rajdhani-semibold mt-2">
                                    {item?.expensehead?.name}
                                  </h4>
                                  {item?.underBudget ? (
                                    <span className="badge bg-green-25 fw-normal rounded-pill">
                                      Under Budget
                                    </span>
                                  ) : (
                                    <span className="badge bg-red-25 fw-normal rounded-pill">
                                      out of budget
                                    </span>
                                  )}
                                </li>
                                <li className="col-12 px-0">
                                  <p>
                                    <span className="text-muted fs-5 d-block">
                                      Allocate Budget :-
                                    </span>
                                    {formatAmount(item?.expectedAmount) || "--"}
                                  </p>
                                </li>
                                <li className="col-12 d-flex align-items-center justify-content-between px-0 mb-2">
                                  <p>
                                    <span className="text-muted fs-5 d-block">
                                      Remaining Budget :-
                                    </span>
                                    {formatAmount(item?.difference) || "--"}
                                  </p>
                                </li>
                              </ul>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-12 ">
                <div className="card manage-user-list">
                  <div className="card-body">
                    <div className="d-flex align-items-center justify-content-between border-bottom mb-3">
                      <h4 className="d-flex align-items-center mb-4">Documents</h4>
                    </div>
                    <ul className="row list-unstyled gap-3">
                      {pageStates?.purchaseData?.documents?.length > 0 ? (
                        pageStates?.purchaseData?.documents?.map((doc, index) => {
                          return (
                            <li key={index} className="col-12">
                              <div
                                className="text-muted fs-5 d-flex align-items-center justify-content-between text-decoration-none w-100"
                                onClick={() => handleDocumentClick(doc)}
                                role="button"
                              >
                                <span className="d-flex align-items-center gap-2">
                                  <DocumentIcon />
                                  {doc?.name || "Document"}
                                </span>
                                <span className="fs-6">
                                  {doc?.updatedAt ? moment(doc?.updatedAt).format("DD MMM YYYY | h:mm a") : ""}
                                </span>
                              </div>
                            </li>
                          );
                        })
                      ) : (
                        <div>No Document Found</div>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group mb-3">
                <label htmlFor="totalLeavePerMonth" className="form-label">
                  Description
                </label>
                <CKEditor
                  editor={ClassicEditor}
                  data={pageStates?.purchaseData?.description || ""}
                  disabled={true}
                  config={{
                    toolbar: [],
                    readOnly: true,
                    image: {
                      toolbar: [
                        "imageStyle:alignLeft",
                        "imageStyle:alignCenter",
                        "imageStyle:alignRight",
                        "|",
                        "imageTextAlternative",
                      ],
                    },
                  }}
                />
              </div>
            </div>
            {(pageStates?.purchaseData?.status?.includes("Approved") ||
              pageStates?.purchaseData?.status?.includes("Director Created") ||
              pageStates?.purchaseData?.status?.includes("Short Closed")) && (
                <>
                  <h4 className="mb-4">Payment Tickets </h4>
                  <div className="card">
                    <div className="card-body">
                      <CommonTable
                        TableHeading={TableHeadingAgainstPo}
                        TableData={pageStatesPT?.PaymentTicketList}
                        ActionData={ActionData}
                        isLoading={pageStatesPT?.tableLoader}
                      />
                    </div>
                  </div>
                </>
              )}

            {pageStates?.purchaseData?.canViewGRN &&
              userDetails?.designation?.canCreate?.includes("grn") && (
                <>
                  <h4 className="mb-4">Goods Received Note (GRN) </h4>
                  <div className="card">
                    <div className="card-body">
                      <CommonTable
                        TableHeading={TableHeadingForGRN}
                        TableData={pageStatesGRN?.GRN_List}
                        ActionData={ActionDataForGRN}
                        isLoading={pageStatesGRN?.tableLoader}
                      />
                    </div>
                  </div>
                </>
              )}
          </div>
        </form>
      </div>
      <Logs
        type={"purchase"}
        id={id}
        refreshLogs={refreshLogs}
        setRefreshLogs={setRefreshLogs}
      />
      <ApproveRejectModal
        modal={modal}
        toggle={toggle}
        submitHandler={(reason) =>
          handleReqStatus(
            modalType === "reject"
              ? "Rejected"
              : modalType === "shortClose"
                ? "Short Closed"
                : "Approved",
            reason,
          )
        }
        isLoading={pageStates.loading}
        actionType={modalType}
      />
      <ViewDocumentModal
        modal={documentModal}
        toggle={toggleDocumentModal}
        selectedDocument={selectedDocument}
      />

      <Modal isOpen={increaseBudgetModal} toggle={toggleIncreaseBudgetModal} centered>
        <ModalBody className="text-center">
          <div className="d-flex flex-column justify-content-center align-items-center gap-4 py-4">
            <h4 className="mb-4 text-center">Are you sure you want to send a budget increase request?</h4>
            <div className="row m-0 w-100">
              <div className="col-12 col-md-6 ps-0 pe-3">
                <button
                  type="button"
                  className="btn btn-secondary w-100"
                  onClick={toggleIncreaseBudgetModal}
                >
                  Cancel
                </button>
              </div>
              <div className="col-12 col-md-6 pe-0 ps-3">
                <button
                  className="btn btn-warning w-100"
                  onClick={() => handleIncreaseSiteBudget()}
                  disabled={pageStates?.IncreaseLoading}
                >
                  {pageStates?.IncreaseLoading ? <Spinner size="sm" /> : "Confirm"}
                </button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}
